module.exports = __webpack_public_path__ + "static/assets/12fffb88cc245027ce8ab2c020be8318.png";